import { render, staticRenderFns } from "./DashRequPush9004.vue?vue&type=template&id=64805857&scoped=true&"
import script from "./DashRequPush9004.vue?vue&type=script&lang=js&"
export * from "./DashRequPush9004.vue?vue&type=script&lang=js&"
import style0 from "./DashRequPush9004.vue?vue&type=style&index=0&id=64805857&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64805857",
  null
  
)

export default component.exports